import styled, { css } from 'styled-components';

export const Container = styled.section(
  ({ theme }) => css`
    width: 100%;
    padding: ${theme.sz.s4};
    border: ${theme.bo.thinWidth} dashed ${theme.co.primary70};
    border-radius: ${theme.bo.medium};
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xxxs};
    margin: 0 0 ${theme.sz.s3};
    color: ${theme.co.neutral40};
    letter-spacing: 0.04em;
    text-align: center;
    text-transform: uppercase;
  `,
);

export const Items = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s1};
    text-align: center;
  `,
);

export const Flower = styled.div(
  ({ theme }) => css`
    display: flex;
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};

    > div,
    svg {
      width: 100%;
      height: 100%;
    }
  `,
);

export const Label = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${theme.co.neutral10};
  `,
);

export const Hint = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.neutral40};
  `,
);
